import {AppAuditLogEntry, DataTableCellProps, TemporalFormat, tryParseInstant} from "@variocube/app-ui";
import {createElement} from "react";

export function AuditCreated({row}: DataTableCellProps<AppAuditLogEntry>) {
	return <TemporalFormat dateStyle="short" timeStyle="medium" value={tryParseInstant(row.created)} />;
}
